import React from 'react';
import Styles from './CategoryLabel.module.less';
import { classes } from '../../../lib';
import { BlogPostCategory } from './BlogPost';

export const CategoryLabel = ({
    title,
    color,
}: Omit<BlogPostCategory, 'slug' | 'count'>): JSX.Element => {
    return (
        <span className={classes(Styles.category, color && Styles[color])}>
            {title}
        </span>
    );
};
